export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">快捷入口</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">多端访问51cg官方平台，随时随地获取最新内容</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-600"></i>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">移动端快捷访问</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  51cg已全面适配移动端浏览器访问。您可以直接在手机浏览器中输入51cg官方域名，即可获得流畅的移动端浏览体验，无需下载额外应用。
                </p>
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-2">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-50 text-secondary-700 rounded-lg text-xs font-medium">
                    <i className="ri-global-line"></i> 浏览器直达
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-50 text-secondary-700 rounded-lg text-xs font-medium">
                    <i className="ri-smartphone-line"></i> 移动适配
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-50 text-secondary-700 rounded-lg text-xs font-medium">
                    <i className="ri-shield-check-line"></i> 安全连接
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}